import {BaseTileProvider} from './base-tile-provider';
import {sprintf} from 'sprintf-js';
import {MapProvider} from '../../enums/map-provider.enum';
import {MapType} from '../../enums/map-type';
import {SettingsService} from '../../services/settings.service';

export class WorldStreetMapTileProvider extends BaseTileProvider {

  private static URL_ARCGIS_WORLD_STREET_MAP = 'https://services.arcgisonline.com/arcgis/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}';

  getMapProvider(): string {
    return MapProvider.ARCGIS_WORLD_STREET_MAP;
  }

  getMaxZoom(): number {
    return 19;
  }

  getUrlTemplate(mapType?: MapType): string {
    return WorldStreetMapTileProvider.URL_ARCGIS_WORLD_STREET_MAP;
  }

  getUrl(x, y, zoom, mapType?: MapType): string {
    return this.getUrlTemplate(mapType)
      .replace('{z}', zoom)
      .replace('{x}', x)
      .replace('{y}', y);
  }

}
